import { useLanguage } from "@/lib/LanguageProvider";

/**
 * LanguageToggle — sélecteur FR / EN discret pour le Guide du Voyageur.
 *
 * Style : un petit "FR · EN" typographique en haut à droite, la langue
 * active en rubis et la langue inactive en encre souple. Aucun cadre.
 * Se place en absolute (top-right) au-dessus des barres de navigation
 * du Guide et de ses chapitres.
 */
export default function LanguageToggle() {
  const { lang, setLang } = useLanguage();
  return (
    <div
      data-testid="guide-lang-toggle"
      className="absolute top-6 md:top-8 right-5 sm:right-8 z-30 flex items-center gap-1.5 font-body text-[11px] tracking-[0.24em] uppercase select-none"
      aria-label="Language toggle"
    >
      <button
        type="button"
        onClick={() => setLang("fr")}
        data-testid="guide-lang-fr"
        aria-pressed={lang === "fr"}
        className="transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--cr-ruby)]/30 rounded-sm px-1"
        style={{
          color: lang === "fr" ? "var(--cr-ruby)" : "var(--cr-ink-soft)",
          opacity: lang === "fr" ? 1 : 0.55,
          fontWeight: lang === "fr" ? 500 : 400,
        }}
      >
        FR
      </button>
      <span
        aria-hidden="true"
        style={{ color: "var(--cr-ink-soft)", opacity: 0.35 }}
      >
        ·
      </span>
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="guide-lang-en"
        aria-pressed={lang === "en"}
        className="transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--cr-ruby)]/30 rounded-sm px-1"
        style={{
          color: lang === "en" ? "var(--cr-ruby)" : "var(--cr-ink-soft)",
          opacity: lang === "en" ? 1 : 0.55,
          fontWeight: lang === "en" ? 500 : 400,
        }}
      >
        EN
      </button>
    </div>
  );
}
